'use strict';

import {ngDepModel} from './ngdepmodel.js';
import {evlFieldModel} from './evlfieldmodel.js';

export class periodicReportChecklistDataModel extends ngDepModel
{
	
	questions = {};
	fields = {};
	conclusion = {};
	
	
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	beforeSetup(data){
		if(typeof(data.questions) !== 'undefined'){
			for(let id in data.questions){
				data.questions[id] = new evlFieldModel(data.questions[id], this._services.$filter, this._services.jsDataService);
			}
		}
		if(typeof(data.fields) !== 'undefined'){
			for(let id in data.fields){
				data.fields[id] = new evlFieldModel(data.fields[id], this._services.$filter, this._services.jsDataService);
			}
		}
		if(typeof(data.conclusion) !== 'undefined'){
			for(let id in data.conclusion){
				data.conclusion[id] = new evlFieldModel(data.conclusion[id], this._services.$filter, this._services.jsDataService);
			}
		}
	}
	
	afterSetup(data){
		
		if(typeof(this.reportFrom) !== 'undefined' && this.reportFrom > 0){
			this.reportFrom_obj = new Date(this.reportFrom * 1000);
		}
		else{
			this.reportFrom_obj = new Date();
		}
		
		if(typeof(this.reportUntil) !== 'undefined' && this.reportUntil > 0){
			this.reportUntil_obj = new Date(this.reportUntil * 1000);
		}
		else{
			this.reportUntil_obj = new Date();
		}
	}
	
	getQuestionsData(){
		let obj = Object.assign({}, angular.copy(this.questions));
		for(let id in obj){
			if(obj[id] instanceof evlFieldModel){
				obj[id] = obj[id].getData();
			}
		}
		return obj;
	}

	getConclusionData(){
		let obj = Object.assign({}, angular.copy(this.conclusion));
		for(let id in obj){
			if(obj[id] instanceof evlFieldModel){
				obj[id] = obj[id].getData();
			}
		}
		return obj;
	}
	
	getFieldsData(){
		let obj = Object.assign({}, angular.copy(this.fields));
		for(let id in obj){
			if(obj[id] instanceof evlFieldModel){
				obj[id] = obj[id].getData();
			}
		}
		return obj;
	}
	
	getConclusion(id){
		if(typeof(this.conclusion[id]) === 'undefined'){
			return null;
		}
		let name = 'value';
		if(arguments[1]){
			name = arguments[1];
		}
		switch(name){
			case 'value':
				return this.s('$filter')('currency')(this.conclusion[id][name]);
			case 'comment':
				return this.s('$filter')('nl2br')(this.conclusion[id][name]);
		}
		return this.conclusion[id].getValue(name);
	}
	
	getQuestion(id){
		if(typeof(this.questions[id]) === 'undefined'){
			return null;
		}
		let name = 'value';
		if(arguments[1]){
			name = arguments[1];
		}
		switch(name){
			case 'value':
				return this.questions[id].getClassifValue(name, 'yesnonot');
			case 'comment':
			case 'title':
				return this.s('$filter')('nl2br')(this.questions[id][name]);
		}
		return this.questions[id].getValue(name);
	}
	
	getValue(name){
		switch(name){
			case 'reportFrom':
			case 'reportUntil':
				if(typeof(this[name]) === 'undefined' || this[name] < 1){
					return null;
				}
				return this.s('$filter')('u2date')(this[name], 'dd/MM/yyyy');
			
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		
		return null;
	}
	
	getData(){
		let data = super.getData();
		if(typeof(data.conclusion) !== 'undefined'){
			data.conclusion = this.getConclusionData();
		}
		if(typeof(data.fields) !== 'undefined'){
			data.fields = this.getFieldsData();
		}
		if(typeof(data.questions) !== 'undefined'){
			data.questions = this.getQuestionsData();
		}
		delete data.reportFrom_obj;
		delete data.reportUntil_obj;
		return data;
	}
	
	getAllData(){
		return {
			conclusion: this.getConclusionData(),
			fields: this.getFieldsData(),
			questions: this.getQuestionsData()
		};
	}
	
	
}
